import { FunctionComponent } from 'react';
import ListSubheader from '@mui/material/ListSubheader';
import { SectionLabelTypography } from '@cbridge-tools/typografy';
import { INavigationHeaderProps } from './NavigationHeader.interface';
import { NavigationHeaderStyle } from './NavigationHeader.style';

export const NavigationHeader: FunctionComponent<INavigationHeaderProps> = (props) => {
  const { title, action, component } = props;

  if (!title && !action) {
    return null;
  }

  return (
    <ListSubheader
      component={component}
      sx={NavigationHeaderStyle}
    >
      <SectionLabelTypography
        color={'textSecondary'}
        sx={{ lineHeight: 2 }}
      >
        {title}
      </SectionLabelTypography>
      {action}
    </ListSubheader>
  );
};
